module.exports = __webpack_public_path__ + "img/background.82693deb.jpg";